import { styled } from '@mui/system'
import BHAvatar from '../avatar'

export const Avatar = styled(BHAvatar)`
	margin-right: 18px;
`
